import template from './mx-shell-toolbar-navigation--popup-item.html';

export const mxShellToolbarNavigationPopupItemComponent = {
	bindings: {
		item: '<',
		level: '<',
	},
	controller: MxShellToolbarNavigationPopupControllerItem,
	controllerAs: 'vm',
	template: template,
};

MxShellToolbarNavigationPopupControllerItem.$inject = ['mx.shell.ToolbarNavigationService'];

function MxShellToolbarNavigationPopupControllerItem(toolbarNavigationService) {
	const vm = this;
	vm.toolbarNavigationService = toolbarNavigationService;
}
